import QuestionGeneratorHelper from '../core/question_generator_helper.js'
import highlightCode from './highlight_code.js'


QuestionGeneratorHelper.prototype.addJSCode = function (source) {
    // We keep this line for safety but answer should be define before by function addCode of language_handler.js
    if (typeof this.answer === 'undefined') {
        this.answer = eval(source) //eslint-disable-line no-eval
    }
    this.container.append(highlightCode(source))
}



